module.exports = __webpack_public_path__ + "ff3034ce353046fe6f0447fd1c8da235.fbx";